<template lang="pug">
v-card.elevation-0.personalisation-card
  v-card.mt-2
    .line
      b {{ title }}
    table.v-datatable.v-table.theme--light.personalisation-table
      thead
        tr
          td(v-for='h in headers'): b {{ h }}
      tbody
        tr(v-for='set in data')
          td(v-for='s in set') {{ s }}
</template>

<script>
export default {
  props: {
    data: Array,
    title: String,
    headers: {
      type: Array,
      default: () => ['Veld', 'Code']
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.personalisation-card {
  box-shadow: none;
  margin-top: 74px;

  .v-card {
    border: $border;
    box-shadow: none;

    .line {
      border-bottom: $border;
      padding: 14px;
    }
  }

  .personalisation-table {
    td {
      padding-right: 15px !important;
      padding-left: 15px !important;
      font-size: 12px;
    }
  }
}
</style>
